import { createSlice } from '@reduxjs/toolkit';

const consentSlice = createSlice({
    name: 'consent',
    initialState: {
      feedbackId:0,
    },
    reducers: {
      setConsentId: (state, action) => {
        // const { fid } = action.payload;
        state.feedbackId = action.payload;
      },
    },
  },
);

export const { setConsentId } = consentSlice.actions;
export default consentSlice.reducer;